import Navigation from './header/Navigation';
import Banner from './header/Banner';
import Tab from './industrialLayout/Tab';
import InDevelopment from './industrialLayout/InDevelopment';
import TraCon from './industrialLayout/TraCon';
import BtCountry from './industrialLayout/BtCountry';
import KeyEn from './industrialLayout/KeyEn';
import KeyPro from './industrialLayout/KeyPro';
import InvesCarrier from './industrialLayout/InvesCarrier';
import IndustrialPolicy from './IndustrialPolicy';
import Footer from './Footer';
import Contact from './Contact';
import '../style/index.css'
import '../style/clear.css';
import { useState } from 'react';

export default function Form() {
  // 当前产业布局类型
  const [proType, setProType] = useState('C-Y-F-Z-G-K');

  return (
    <>
      <Navigation />
      <Banner />
      <div className="lay-title">产业布局</div>
      <Tab onChangeTab={child => setProType(child)} />
      {
        proType === 'C-Y-F-Z-G-K' && <InDevelopment />
      }
      {
        proType === 'J-T-Q-K' && <TraCon />
      }
      {
        proType === 'M-L-X-C' && <BtCountry />
      }
      {
        proType === 'Z-D-Q-Y-F-B' && <KeyEn />
      }
      {
        proType === 'S-S-W-Z-D-G-C' && <KeyPro />
      }
      {
        proType === 'Z-S-Z-T' && <InvesCarrier />
      }
      <div className="lay-title">各类政策</div>
      <IndustrialPolicy />
      <Footer />
      <Contact />
    </>
  );
}